import { useParams } from "react-router-dom";
import { GroupDetailView } from "../components/GroupDetailView";

export function GroupDetailScreen() {
  const { groupId } = useParams<{ groupId: string }>();

  if (!groupId) {
    return <p>Group not found.</p>;
  }

  return <GroupDetailView groupId={groupId} />;
}
